export default "__VITE_ASSET__ErXvzqQI__"